export default __webpack_public_path__ + "assets/png/c3c8af133ad23b4ec8063f49c426a8f0.png";